<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { buildOrganizationJsonLd, buildSeoMetaInfo, createJsonLdScript, ROUTE_SEO } from './utils/seo'

export default {
  name: 'App',
  metaInfo() {
    const seo = (this.$route.meta && this.$route.meta.seo) || ROUTE_SEO.Index
    const metaInfo = buildSeoMetaInfo(seo, this.$route)
    return {
      ...metaInfo,
      script: [
        ...(metaInfo.script || []),
        createJsonLdScript('jsonld-organization', buildOrganizationJsonLd())
      ]
    }
  }
}
</script>

<style>
html {
  overscroll-behavior-y: none;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
body {
  margin: 0;
  padding: 0;
  font-family: var(--font-sans);
  font-size: var(--text-body);
  line-height: var(--leading-body);
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  touch-action: manipulation;
  overscroll-behavior-y: none;
}
h1, h2, h3, h4, h5, h6  {
  margin: 0;
  padding: 0;
  font-family: var(--font-heading);
  font-weight: normal;
}
button, input, select, textarea {
  font: inherit;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0;
  padding: 0;
}
a {
  font-style: normal;
  text-decoration: none;
}
p {
  margin: 0;
  padding: 0;
}
div {
  box-sizing: border-box;
}

.scroll-reveal {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}

.scroll-reveal.is-pending,
.scroll-reveal.is-visible {
  transition: all 0.8s cubic-bezier(0.5, 0, 0, 1);
  will-change: opacity, transform, filter;
}

.scroll-reveal.is-pending {
  opacity: 0;
  transform: translateY(30px);
  filter: blur(10px);
}

.scroll-reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}

@media (prefers-reduced-motion: reduce) {
  .scroll-reveal,
  .scroll-reveal.is-pending,
  .scroll-reveal.is-visible {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
    transition: none;
    will-change: auto;
  }
}

@media (max-width: 768px) {
  #app {
    overflow-x: hidden;
  }
  
  button {
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  a {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }
}
</style>
